import { render } from "./Nonpayment.vue?vue&type=template&id=00efc9ae&scoped=true"
import script from "./Nonpayment.vue?vue&type=script&lang=js"
export * from "./Nonpayment.vue?vue&type=script&lang=js"

import "./Nonpayment.vue?vue&type=style&index=0&id=00efc9ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00efc9ae"]])

export default __exports__